export default __webpack_public_path__ + "static/qz-324e7b7f24be95ab2cbb10057d262d67.png";